import { isNullOrEmpty, translate } from '../../utils/util';

const TableUI = ({ col, data, actions, totalPages, current, type, disablePaged, noRows, onClickRow }) => {
    const currentPage = current ? current.currentPage : {};
    const startPage = Math.max(0, currentPage.pageIndex || 0 - 3);
    const endPage = Math.min(totalPages - 1, currentPage.pageIndex + 3);

    const messageNoRows = isNullOrEmpty(noRows) ? translate('general:no-registry') : noRows;

    const requestSort = (key) => {
        let direction = 1;
        if (currentPage.sortField === key && currentPage.sortOrder === 1) {
            direction = -1;
        }

        currentPage.sortField = key;
        currentPage.pageIndex = 0;
        currentPage.sortOrder = direction;
        current.setCurrentPage({ ...currentPage });
    };

    const onClickLine = (row) => {
        if (onClickRow) {
            return onClickRow(row)
        }
    }

    return (
        <div style={{ padding: '10px' }}>
            <table className={`${!isNullOrEmpty(type) ? type : 'highlight'} `}
                style={{ backgroundColor: 'white', boxShadow: '0 2px 7px 0 rgba(0,0,0,0.2)' }}
            >
                <thead>
                    <tr>
                        {col.map((item) => (
                            <th key={item.field}
                                className={item.align ? `align-${item.align}` : ""}
                                onClick={() => { item.sortable && requestSort(item.field) }}
                                style={{ cursor: item.sortable ? 'pointer' : '' }}>
                                {item.header}
                                {item.sortable && currentPage.sortField === item.field && (
                                    <i className="material-icons" style={{ marginLeft: "2px" }}>
                                        {currentPage.sortOrder === -1 ? 'arrow_upward' : 'arrow_downward'}
                                    </i>
                                )}
                            </th>
                        ))}
                        {actions && actions.length > 0 && <th>Ações</th>}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr
                            key={row.id || `row-${rowIndex}`}
                            onClick={() => onClickLine(row)}
                            style={{ border: '1px solid #ddd', padding: '8px' }}
                        >
                            {col.map((item) => (
                                <td key={item.field} className={item.align ? `align-${item.align}` : ""}>
                                    {item.body ? item.body(row) : row[item.field]}
                                </td>
                            ))}
                            {actions && actions.length > 0 && (
                                <td key="actionsTable" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    {actions.map((action, indexAction) => (
                                        <span key={`indexAction-${indexAction}`}>
                                            {action.function(row)}
                                        </span>
                                    ))}
                                </td>
                            )}
                        </tr>
                    ))}
                    {
                        data.length === 0 &&
                        <tr style={{ border: '1px solid #ddd' }}>
                            <td colSpan={999} style={{ textAlign: 'center' }} >
                                {messageNoRows}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
            {
                !disablePaged && <div className="row" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
                    <i className="material-icons"
                        onClick={() => {
                            if (currentPage.pageIndex !== 0) {
                                currentPage.pageIndex = currentPage.pageIndex - 1;
                                current.setCurrentPage({ ...currentPage });
                            }
                        }}
                        style={{ fontSize: "3rem", cursor: "pointer", color: currentPage.pageIndex === 0 ? "gray" : "" }}>
                        keyboard_arrow_left
                    </i>
                    {startPage > 0 && (
                        <>
                            <button
                                type="button"
                                className={`btn ${currentPage.pageIndex === 0 ? "blue darken-2" : ""}`}
                                onClick={() => {
                                    currentPage.pageIndex = 0;
                                    current.setCurrentPage({ ...currentPage });
                                }}>1</button>
                            {startPage > 1 && <span style={{ margin: "0 5px" }}>...</span>}
                        </>
                    )}

                    {Array.from({ length: endPage - startPage + 1 }, (_, index) => {
                        const pageNumber = startPage + index;
                        return (
                            <button
                                type="button"
                                key={pageNumber - 1}
                                className={`btn ${currentPage.pageIndex === pageNumber ? "btn-principal" : ""}`}
                                onClick={(e) => {
                                    e.currentTarget.blur();
                                    currentPage.pageIndex = pageNumber;
                                    current.setCurrentPage({ ...currentPage });
                                }}
                                style={{ margin: "0 5px", borderRadius: '5px' }}
                            > {pageNumber + 1}
                            </button>
                        );
                    })}

                    {endPage < totalPages - 1 && (
                        <>
                            {endPage < totalPages - 2 && <span style={{ margin: "0 5px" }}>...</span>}
                            <button
                                type="button"
                                className={`btn ${currentPage.pageIndex === totalPages - 1 ? "blue darken-2" : ""}`}
                                onClick={() => {
                                    //-1 pois inicia do 0
                                    currentPage.pageIndex = totalPages - 1;
                                    current.setCurrentPage({ ...currentPage });
                                }}>
                                {totalPages}
                            </button>
                        </>
                    )}

                    <i className="material-icons"
                        onClick={() => {
                            if (currentPage.pageIndex !== totalPages - 1) {
                                currentPage.pageIndex = currentPage.pageIndex + 1;
                                current.setCurrentPage({ ...currentPage });
                            }
                        }}
                        style={{ fontSize: "3rem", cursor: "pointer", color: currentPage.pageIndex === totalPages - 1 ? "gray" : "" }}>
                        keyboard_arrow_right
                    </i>
                    <select
                        className="browser-default"
                        value={currentPage.pageSize}
                        onChange={(e) => {
                            currentPage.pageIndex = 0;
                            currentPage.pageSize = parseInt(e.target.value)
                            current.setCurrentPage({ ...currentPage });
                        }}
                        style={{ width: "auto", padding: "5px 10px", borderRadius: "5px", border: "1px solid #ccc" }}
                    >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                    </select>
                </div>
            }
        </div>
    );
};

export default TableUI;